// CheckIcon.jsx — theme-aware completion glyph.
//
// In every theme except Girlboss this renders as the standard check mark
// used across the app (task done, goal done, habit done, etc). In Girlboss
// it swaps for a heart so the celebratory moment carries the theme's voice.
//
// This is the only place in the app that should select between check and
// heart — call sites just render <CheckIcon size=... color=.../> and never
// need to know what theme is active. Keeps the themeStore dependency
// surgical instead of leaking into every component that shows completion.
//
// Re-renders on theme change via useSyncExternalStore on themeStore, so
// flipping themes in the Appearance sheet updates every visible checkmark
// immediately without a reload.

import { useSyncExternalStore } from 'react';
import { Icon } from './Icon.jsx';
import * as themeStore from '../lib/themeStore.js';

export function CheckIcon(props) {
  const theme = useSyncExternalStore(themeStore.subscribe, themeStore.getSnapshot, themeStore.getSnapshot);
  const name = theme === 'girlboss' ? 'heart' : 'check';
  return <Icon {...props} name={name} />;
}
